import React from "react";
import { useSelector } from "react-redux";
import { appdataSelector } from "reducers/appdata/appdata";
import { vendordataSelector } from "reducers/vendordata/vendordata";
import Link from "@mui/material/Link";
import { useNavigate } from "react-router";

function Feedback(props) {
    const vendordata = useSelector(vendordataSelector)
    const appdata = useSelector(appdataSelector);
    const navigate = useNavigate();

    let containerClass = "no-breadcrumb chapter mt-4";
    if (!appdata.isResetRequest) {
        containerClass += " container-fluid"
    }

    return (
        <article className="article">
            <div className={containerClass}>

                {appdata.isResetRequest && <span>Thank you, this request has been updated and sent to the first Approver again.</span>}

                {!appdata.isResetRequest && vendordata.activeVendor.master &&
                    vendordata.activeVendor.master.requestID && (
                        <React.Fragment>
                            <h2 className="article-title">{props.header}</h2>
                            <div className="mt-4">
                                Thank you, request with id
                                <Link
                                    key="reqidbtn"
                                    component="button"
                                    variant="body2"
                                    onClick={() => {
                                        navigate("/app/vendor/" + vendordata.activeVendor.master.requestID);
                                    }}
                                >
                                    &nbsp;{vendordata.activeVendor.master.requestID}{" "}
                                </Link>

                                &nbsp;has been created.
                            </div>
                        </React.Fragment>
                    )}
            </div>
        </article>

    )
}

export default Feedback